import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import StyleModule from './modules/style-module'
import WarehouseModule from './modules/warehouse-module'
import OrderModule from './modules/order-module'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    Style: StyleModule,
    Warehouse: WarehouseModule,
    Order: OrderModule
  },
  plugins: [
    vuexLocal.plugin
  ]
})
